"use client";
import LinkButton, { LinkButtonVariant } from "../LinkButton";

export default function WorkshopCard({
  title,
  date,
  calendarLink,
  calendarLabel,
  description,
}: {
  title: string;
  date: string;
  calendarLink: string;
  calendarLabel: string;
  description: string;
}) {
  return (
    <div className="flex flex-col justify-between border border-dashed border-green p-5 bg-black/60 workshop-card">
      <div>
        <p className="text-white text-md font-roboto-mono font-medium">
          {date}
        </p>
        <h4 className="font-anybody-condensed font-light text-green text-6xl uppercase mt-2">
          {title}
        </h4>
        <p className="text-white text-lg mt-2 font-roboto-mono font-bold">
          {description}
        </p>
      </div>
      <LinkButton
        variant={LinkButtonVariant.SMALL}
        href={calendarLink}
        className="mt-6"
        linkName={`view_workshop_${title.toLowerCase().replace(/ /g, "_")}`}
      >
        {calendarLabel}
      </LinkButton>
    </div>
  );
}
